import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../../i18n';
import TimerIcon from '../../../../icons/TimerIcon';
import TileDrawerHeaderLayout from '../../../shared/TileDrawerHeaderLayout';

const DrawerHeader = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  return (
    <TileDrawerHeaderLayout icon={TimerIcon} color="warning">
      {t('timer', { ns: i18nNS.GLOSSARY })}
    </TileDrawerHeaderLayout>
  );
};

export default DrawerHeader;
